import styled, { css } from 'styled-components'

// const lstPxs = [60, 200, 110, 160, 140, 110, 90, 120, 400]
// const sumPx = lstPxs.reduce((total, curr) => total + curr)
// const gridArr = lstPxs.map(
//     (item) => `minmax(${item}px, ${Math.round((item / sumPx) * 100)}fr)`
// )

const lstPxs = [115, 290, 170, 170, 170, 170, 170, 115, 500]
const gridArr = lstPxs.map((item) =>
    typeof item === 'number' ? `${item}px` : item
)

const extendStylesTable = css`
    .header,
    .row {
        grid-template-columns: ${gridArr.join(' ')};
    }
`

const extendStylesTeller = css`
    width: 220px;
`

export { extendStylesTable, extendStylesTeller }
